import { MRT_Row } from "material-react-table";
import type { Job, Deal } from "../../../../../../models";
import { getDealLabel } from "../../../../../../utilities/utils";
import { DealOption } from "./Deal.column.types";
/**
 * Get option label for Cell display
 */
export function getDealOptionLabel(deal: DealOption): string {
	if (deal && deal.id === "custom") {
		return "No linked Configuration";
	} else {
		return getDealLabel(deal as Deal);
	}
}

/**
 * Get option label for AggregatedCell display
 */
export function getGroupDealOptionLabel(option: DealOption): string {
	if (option && option.id === "custom") {
		return "Unlink All Configurations for Group";
	} else {
		const d = option as Deal;
		const dealLabelFields = [d.density, d.type, d.depth, d.testPackage || "No test package specified"];
		if (d.specialTag) dealLabelFields.push(d.specialTag);
		dealLabelFields.push(d.season);
		return `${d.density} Acre ${dealLabelFields.join(" - ")}`;
	}
}

/**
 * Update MRT row cache from job (for Cell)
 */
export function updateRowCacheFromJob(row: MRT_Row<Job>, job: Job): void {
	row._valuesCache.dealIds = job.dealIds;
	row._valuesCache.importDensity = job.importDensity;
	row._valuesCache.importDepth = job.importDepth;
	row._valuesCache.importTestPackage = job.externalTestPackageId;
	row._valuesCache.externalFrequencyOfMicros = job.externalFrequencyOfMicros;
}
